module.exports = __webpack_public_path__ + "f84876752ebb119309d9d423d66f737f.svg";